import { Injectable } from '@angular/core';
import { DataService } from 'projects/Autofacets-Core/src/app/services/data.service';
import { Urls } from 'projects/Autofacets-Core/src/app/utils/urls';
import { GenericResponse } from '../business-entities/generic-response';
import { EmployeeResource, MechanicLineAssignmentItem, MechanicLineAssignmentSaveRequest } from '../business-entities/mechanic-line-assignment.model';

@Injectable({
  providedIn: 'root'
})
export class MechanicLineAssignmentDataService {

  constructor(private readonly dataProvider: DataService) { }

  getMechanicLineAssignment(appointmentId: number): Promise<GenericResponse<MechanicLineAssignmentItem[]>> {
    return this.dataProvider.Get<GenericResponse<MechanicLineAssignmentItem[]>>(
      Urls.GetMechanicLineAssignment, appointmentId
    ).toPromise();
  }

  getMechanicLineAssignmentByDetail(appointmentId: number, appointmentJobDetailId: number): Promise<GenericResponse<MechanicLineAssignmentItem[]>> {
    return this.dataProvider.Get<GenericResponse<MechanicLineAssignmentItem[]>>(
      Urls.GetMechanicLineAssignment, appointmentId, appointmentJobDetailId
    ).toPromise();
  }

  saveMechanicLineAssignment(request: MechanicLineAssignmentSaveRequest): Promise<GenericResponse<any>> {
    return this.dataProvider.Post<GenericResponse<any>>(
      Urls.SaveMechanicLineAssignment, request
    ).toPromise();
  }

  getEmployeeResources(): Promise<GenericResponse<EmployeeResource[]>> {
    return this.dataProvider.Get<GenericResponse<EmployeeResource[]>>(
      Urls.GetEmployeeResources
    ).toPromise();
  }

  syncMechanicLineAssignment(appointmentId: number, appointmentJobDetailId: number): Promise<GenericResponse<MechanicLineAssignmentItem[]>> {
    return this.dataProvider.Get<GenericResponse<MechanicLineAssignmentItem[]>>(
      Urls.SyncMechanicLineAssignment, appointmentId, appointmentJobDetailId
    ).toPromise();
  }
}
